<template>
  <div class="basket-box-modal">
    <ModalAsideHeader>
      {{ packagingAndAccessories }}
    </ModalAsideHeader>
    <ModalAsideBody>
      <div class="basket-box-modal-header">
        <BasketBoxModalSlider :result="getActiveBox" />
        <BasketBoxModalDescription :result="getActiveBox" :product="result" />
      </div>
      <div v-if="boxes.length > 1" class="basket-box-modal-footer">
        <h2 class="basket-box-modal-footer__title">
          {{ availableOptions }}
        </h2>

        <div>
          <DefSlider ref="pagination" :settings="settings" :nav="false">
            <div
              v-for="(item, i) in boxes"
              :key="i"
              :class="{ active: item.isBoxSelected }"
              class="swiper-slide"
              @click="handlerChangeActiveBox(i)"
            >
              <BasketBoxModalReview :result="item" />
            </div>
          </DefSlider>
        </div>
      </div>
    </ModalAsideBody>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import BasketBoxModalSlider from '@components/Basket/BasketBox/BasketBoxModal/BasketBoxModalSlider.vue';
import BasketBoxModalDescription from '@components/Basket/BasketBox/BasketBoxModal/BasketBoxModalDescription.vue';
import DefSlider from '@components/Def/DefSlider/DefSlider.vue';
import BasketBoxModalReview from '@components/Basket/BasketBox/BasketBoxModal/BasketBoxModalReview.vue';
import ModalAsideHeader from '@use/useModalAside/ModalAsideHeader.vue';
import Analytics from '@/utils/Analytics';
import ModalAsideBody from '@use/useModalAside/ModalAsideBody.vue';

export default {
  name: 'BasketBoxModal',
  components: {
    ModalAsideBody,
    ModalAsideHeader,
    BasketBoxModalReview,
    DefSlider,
    BasketBoxModalDescription,
    BasketBoxModalSlider,
  },
  props: ['result'],
  data() {
    return {
      settings: {
        slidesPerView: 2.8,
        spaceBetween: 8,
        breakpoints: {
          768: {
            slidesPerView: 4.8,
          },
          992: {
            slidesPerView: 6.8,
          },
        },
      },
      activeSlide: 1,
      boxes: [...this.result.boxes.filter((el) => el.isAvailable)],
    };
  },
  computed: {
    ...mapState({
      availableOptions: ({ basket }) => basket.data.messages?.box?.availableOptions,
      packagingAndAccessories: ({ basket }) => basket.data.messages?.box?.packagingAndAccessories,
    }),
    getActiveBox() {
      return this.boxes.find((el) => el.isBoxSelected);
    },
  },
  watch: {
    getActiveBox(newValue) {
      Analytics.viewDetailProduct(newValue);
    },
  },
  beforeMount() {
    this.handlerChangeActiveBox(0);
  },
  mounted() {
    Analytics.viewDetailProduct(this.getActiveBox);
  },
  methods: {
    handlerChangeActiveBox(i) {
      this.boxes = this.boxes.map((item, key) => ({
        ...item,
        isBoxSelected: i === key,
      }));
    },
  },
};
</script>

<style lang="scss" scoped>
.basket-box-modal {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  :deep(.def-slider__next) {
    right: 0;
  }
  :deep(.def-slider__prev) {
    left: 0;
  }
}
.basket-box-modal-header {
  display: grid;
  grid-row-gap: 24px;
  grid-template-columns: minmax(0, 1fr);
  margin-bottom: 24px;
  @include point-md {
    grid-template-columns: minmax(0, 368px) minmax(0, 1fr);
    grid-column-gap: 24px;
    margin-bottom: 32px;
  }
  @include point-lg {
    grid-template-columns: minmax(0, 462px) minmax(0, 1fr);
    grid-column-gap: 60px;
  }
}
.basket-box-modal-footer {
  &__title {
    font-size: 14px;
    font-weight: 600;
    line-height: 125%;
    text-transform: uppercase;
    margin-bottom: 16px;
    @include point-md {
      font-size: 16px;
    }
  }
  .swiper-slide {
    transition: 0.2s linear border-color;
    cursor: pointer;
    border: 1px solid #e0e0e0;
    &.active {
      border-color: #3d3d51;
    }
  }
}
</style>
